const Members = () => {return(window.location.assign(process.env.REACT_APP_NEWS_API_BASE_URL + 'login'))}
export default Members;
